import {
  OnboardingSettingsSnapshot,
  Prospect,
} from '@nxsys/store/slices/prospect/types';

/**
 * The employer settings that govern one onboarding.
 *
 * An onboarding carries the settings it was invited under (`onboardingSettings`
 * on the prospect) instead of re-reading the company row at each step: editing
 * the employer settings used to reshape journeys already in flight — switching
 * `UKVerifiedIdMethod` closed the ID task for employees still being asked for a
 * birth certificate.
 *
 * The fallback is object-level, never per field: a prospect either has a
 * snapshot or it does not. An `onboarding: []` snapshot is a real answer (the
 * employer switched every step off), so a field-by-field `??` chain would
 * silently mix a pinned value with a live one. Mirrors the backend's
 * `resolveOnboardingSettings` in `prospects.onboarding.enity.ts`.
 *
 * Prospects invited before the snapshot existed carry none, and so do
 * candidate-flow prospects until an admin progresses them — those fall back to
 * the live company row, which is what this screen did before.
 *
 * Note this is only for the onboarding journey. The back-office employer
 * settings screen stays on the live company values: it is what edits them.
 */
const resolveOnboardingSettings = (
  prospect?: Prospect | null,
): OnboardingSettingsSnapshot =>
  prospect?.onboardingSettings ?? {
    onboarding: prospect?.companyPayment?.onboarding ?? [],
    UKVerifiedIdMethod: prospect?.companyPayment?.UKVerifiedIdMethod ?? null,
    nonUKVerifiedIdMethod:
      prospect?.companyPayment?.nonUKVerifiedIdMethod ?? null,
    emailOnboardingNotification:
      prospect?.companyPayment?.emailOnboardingNotification ?? null,
  };

export default resolveOnboardingSettings;
